
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { ITipo } from '@/models/Entidades/ITipo';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoTipo from '@/servicos/ServicoTipo';
import { IResposta } from '@/core/models/IResposta';

export default defineComponent({
  name: 'NaturezaCadastro',
  components: {
    ComunicacaoApi,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarRespostaRedirecionamento, obterCodigoRota,
    } = useAppBase();
    const servicotipo = new ServicoTipo();

    const state = reactive({
      tipo: {} as ITipo,
    });

    async function obtertipo(codigo:number) {
      appBase.carregando = true;
      state.tipo = await servicotipo.obter(codigo);
      appBase.carregando = false;
    }

    function limparDados() {
      state.tipo = {} as ITipo;
      state.tipo.codigo = 0;
      state.tipo.status = true;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigotipo = obterCodigoRota();
      if (codigotipo > 0) {
        await obtertipo(codigotipo);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações do tipo.');
      if (state.tipo.codigo === 0) {
        appBase.resposta = await servicotipo.incluir(state.tipo);
      } else {
        appBase.resposta = await servicotipo.atualizar(state.tipo);
      }

      apresentarRespostaRedirecionamento('Tipos');
    }
    return {
      appBase,
      state,
      salvar,
    };
  },
});
